import { TimePicker } from 'antd';
import React from 'react';

const DokanTimePicker = () => {
    const onChange = () => {};
    return <TimePicker use12Hours format="h:mm a" onChange={onChange} className="ml-20px" />;
};

export default DokanTimePicker;
